import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import loginSideImg from "../../assets/login-screen.png";
import useAuth from "./hooks/useAuth";
import { TEXT_LIBRARY } from "../../lib/utils/constants";
import SnackbarUtils from "../../lib/components/Snackbar/utils";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, loading } = useAuth();

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const formData = { email: email, password: password, locale: "en" };
      const data = await login(formData);
      let systemId = data?.system_id || data?.user?.system_id || "";
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const dd = String(today.getDate()).padStart(2, "0");
      const startDate1 = `${yyyy}-${mm}-${dd}`;
      const endDate1 = `${yyyy}-${mm}-${dd}`;
      const params = new URLSearchParams({
        systemId,
        startDate1,
        endDate1,
      }).toString();
      navigate(`/?${params}`, { replace: true });
    } catch (err) {
      let errorMessage = TEXT_LIBRARY.INVALID_CREDENTIALS;
      if (err.response?.data?.status === "UNAUTHORIZED") {
        errorMessage = TEXT_LIBRARY.INVALID_CREDENTIALS;
      } else {
        errorMessage = err.response?.data || err.message || TEXT_LIBRARY.INVALID_CREDENTIALS;
      }
      SnackbarUtils.error(`${errorMessage}`);
    }
  };

  return (
    <div className="min-h-screen flex overflow-hidden w-full">
      <div className="hidden md:flex flex-1 items-center justify-center">
        <img src={loginSideImg} alt="ev charger" className="w-full h-full object-cover" />
        <div className="absolute bg-white/70 rounded-xl p-8 max-w-[370px] min-w-[270px] shadow-lg flex gap-4 items-start">
          <div className="w-8 h-8 rounded-full border-4 border-[#3ec28f] mt-1 flex-shrink-0" />
          <div>
            <div className="font-bold text-lg text-gray-900 mb-2">
              Efficient EV Fleet Charging &<br />
              Management Platform
            </div>
            <div className="text-gray-700 text-base">
              Monitor, control, and optimize your electric vehicle charging infrastructure from a single dashboard.
            </div>
          </div>
        </div>
      </div>
      {/* Right: Form */}
      <div className="flex-1 flex flex-col justify-between bg-white py-10 px-12 min-w-[350px] max-w-[480px]">
        <div>
          <div className="flex items-center justify-between mb-8">
            <span className="text-2xl font-bold tracking-tight">
              EV<span className="text-[#3ec28f]"> Fleet</span>
            </span>
          </div>
          <div className="flex flex-col justify-center ">
            <h1 className="text-3xl font-bold mb-2">Welcome!</h1>
            <p className="text-gray-700 text-base mb-8">
              Sign in to your EV Fleet Management account using your email and password.
            </p>
            <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="username"
                required
                className="px-4 py-3 rounded-lg border border-gray-200 bg-gray-50 text-base outline-none focus:ring-2 focus:ring-[#3ec28f]"
              />
              <input
                type="password"
                placeholder="Your password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                required
                className="px-4 py-3 rounded-lg border border-gray-200 bg-gray-50 text-base outline-none focus:ring-2 focus:ring-[#3ec28f]"
              />
              <div className="text-[#3ec28f] text-sm cursor-pointer mb-[-0.5rem]">Forgot password?</div>
              <button
                type="submit"
                className="bg-black text-white rounded-lg py-3 px-4 text-base font-semibold mt-2 hover:bg-gray-900 transition"
                disabled={loading}
              >
                {loading ? "Signing In..." : "Sign In"}
              </button>
            </form>
            <div className="mt-8 text-base text-gray-800">
              Need help? Contact us
              <br />
              <a href="mailto:support@enphaseenergy.com" className="text-[#3ec28f] underline">
                support@enphaseenergy.com
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 text-gray-400 text-sm">© 2008-2025 Enphase Energy Inc. All rights reserved.</div>
      </div>
    </div>
  );
};

export default Login;
